import moment from 'moment';

export const horaMes = (fecha: Date): string => {
  const hoyMes = moment(fecha);

  return hoyMes.format('HH:mm a | MMMM Do');
};

export const horaMesCalendar = (fecha: Date): string => {
  const hoyMes = moment(fecha);

  return hoyMes.format('l');
};

export const getNameDayOfWeek = (day: number): string => {
  return moment().day(day).format('dddd');
};

export const getNumberDayOfWeek = (day: number): string => {
  return moment().day(day).format('D');
};

export const getDate = (day: number): string => {
  return moment(day).format('l');
};

export const getDateToRequest = (day: number): string => {
  const date = (moment().day(day).format('L') + '')
    .split('/')
    .reverse()
    .join('/');

  return date;
};

export const formatDateOfResponse = (date: number): number => {
  return moment(date).day();
};

export const formatDateRequest = (date: number): string => {
  return moment().day(date).format();
};

export const formatDateCreateTask = (date: Date): string => {
  const dates = moment(date);
  return dates.format('YYYY-MM-DD').toString();
};

export const formatCreatedAt = (date: Date) => {
  return moment(date).format('YYYY-MM-DDTHH:mm:ss');
}

